import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7e68fc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-stage_wrapper" }
const _hoisted_2 = { class: "calendar-stage_header header" }
const _hoisted_3 = { class: "header_title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header_menu" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1789_7896)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M4.5 10.5C3.675 10.5 3 11.175 3 12C3 12.825 3.675 13.5 4.5 13.5C5.325 13.5 6 12.825 6 12C6 11.175 5.325 10.5 4.5 10.5ZM19.5 10.5C18.675 10.5 18 11.175 18 12C18 12.825 18.675 13.5 19.5 13.5C20.325 13.5 21 12.825 21 12C21 11.175 20.325 10.5 19.5 10.5ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z",
        fill: "black"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1789_7896" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "calendar-stage_list list" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list_item" }, "Click me!"),
  /*#__PURE__*/_createElementVNode("div", { class: "list_item" }, "Click me!"),
  /*#__PURE__*/_createElementVNode("div", { class: "list_item" }, "Click me!")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_menu = _resolveComponent("ac-menu")!
  const _component_ac_progress = _resolveComponent("ac-progress")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["calendar-stage", { '-disabled': _ctx.stage.status.status === 'close' }])
  }, [
    _renderSlot(_ctx.$slots, "homeworksBefore", {}, undefined, true),
    _renderSlot(_ctx.$slots, "alertBefore", {}, undefined, true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_ctx.stage.stage.title), 1),
          (_ctx.showMenu)
            ? (_openBlock(), _createBlock(_component_ac_menu, {
                key: 0,
                location: "bottom"
              }, {
                activator: _withCtx(() => [
                  _hoisted_4
                ]),
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_ac_progress, {
          class: "header_progress",
          "model-value": _ctx.stage.percent
        }, null, 8, ["model-value"])
      ]),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _renderSlot(_ctx.$slots, "alertAfter", {}, undefined, true)
  ], 2))
}